import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/Casesquare",
    name: "Case",
    component: () =>
      import(/* webpackChunkName: "about" */ "../H5/Casesquare.vue"),
  },
  {
    path: "/Case",
    name: "Case",
    component: () => import(/* webpackChunkName: "about" */ "../H5/Case.vue"),
  },
  {
    path: "/ContactUs",
    name: "ContactUs",
    component: () =>
      import(/* webpackChunkName: "about" */ "../H5/ContactUs.vue"),
  },
  {
    path: "/demo",
    name: "demo",
    component: () => import(/* webpackChunkName: "about" */ "../H5/demo.vue"),
  },
  {
    path: "/demo1",
    name: "demo1",
    component: () => import(/* webpackChunkName: "about" */ "../H5/demo1.vue"),
  },
  {
    path: "/index",
    name: "Battery Plant",
    component: () => import(/* webpackChunkName: "about" */ "../H5/Home.vue"),
  },
  {
    path: "/Productinformation",
    name: "Productinformation",
    component: () =>
      import(/* webpackChunkName: "about" */ "../H5/Productinformation.vue"),
  },
  {
    path: "/Productslist",
    name: "Productslist",
    component: () =>
      import(/* webpackChunkName: "about" */ "../H5/Productslist.vue"),
  },
  {
    path: "/Project",
    name: "Project",
    component: () =>
      import(/* webpackChunkName: "about" */ "../H5/Project.vue"),
  },
  {
    path: "/admin/Login",
    name: "Login",
    component: () => import(/* webpackChunkName: "about" */ "../PC/Login.vue"),
    meta: {
      isLogin: true,
    },
  },
  {
    path: "/admin/Product",
    name: "Product",
    component: () =>
      import(/* webpackChunkName: "about" */ "../PC/Product.vue"),
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/Gallery",
    name: "Gallery",
    component: () => import(/* webpackChunkName: "about" */ "../PC/Case.vue"),
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/Enquiries",
    name: "Enquiries",
    component: () => import(/* webpackChunkName: "about" */ "../PC/Orders.vue"),
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/Enquiry",
    name: "Enquiry Type",
    component: () =>
      import(/* webpackChunkName: "about" */ "../PC/Intention.vue"),
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/LoginUser",
    name: "LoginUser",
    component: () =>
      import(/* webpackChunkName: "about" */ "../PC/LoginUser.vue"),
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/Homedtxg",
    name: "BatteryPlant",
    component: () => import(/* webpackChunkName: "about" */ "../H5/Homedtxg.vue"),
  },
  {
    path: "*",
    redirect: "/index",
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
});
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem("token");

  if (to.meta.isAdmin) {
    if (!token) {
      next("/admin/Login");
    } else {
      next();
    }
  } else {
    next();
  }
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
